module.exports = __webpack_public_path__ + "static/media/kraftconstructionco.f18fdf77.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/portfolio/kraftconstruction/kraftconstructionco.png
// module id = 52
// module chunks = 0